import { createContext } from 'react'
export interface ManagedVideo {
  id: string
  ref: any
  type: 'blicktv' | 'integrated' | 'youtube'
}

export interface VideoContextType {
  isOverlay?: boolean
  addVideo: (video: ManagedVideo) => void
  pauseVideo: () => void
  showOverlay: () => void
  hideOverlay: () => void
}

const VideoContext = createContext<VideoContextType>({
  isOverlay: false,
  addVideo: () => {},
  pauseVideo: () => {},
  showOverlay: () => {},
  hideOverlay: () => {},
})

const exports = { VideoContext }

export default exports
